import React from 'react';
import { TabsOption } from 'global';
import { UsersTab } from '../ui/pages/userManagementPage/tabs/usersTab/UsersTab';
import { UserAccessTab } from '../ui/pages/userManagementPage/tabs/userAccessTab/UserAccessTab';
import { UserManagementTab } from '../types';

export const getUserManagementTabs = (
  isDealerUser: boolean,
  isSuperAdminOrSingleAccount: boolean
): TabsOption<UserManagementTab>[] => [
  { value: 'users', label: 'Users', urlAnchor: '#users', component: React.createElement(UsersTab) },
  {
    value: 'user-access',
    label: 'User Access',
    urlAnchor: '#user-access',
    component: React.createElement(UserAccessTab),
    isVisible: isDealerUser && isSuperAdminOrSingleAccount,
  },
];
